import { INVOICE_COLUMN_ROLES, type InvoiceColumnRole, type IssueSeverity, type ProfileMatchedBy } from './types'

/** Названия ролей колонок накладной для человека. Значения на проводе — имена членов перечисления. */
export const ROLE_LABELS: Readonly<Record<InvoiceColumnRole, string>> = {
  None: 'Не использовать',
  LineNumber: '№ п/п',
  Name: 'Наименование',
  Sku: 'Артикул',
  Barcode: 'Штрихкод',
  Quantity: 'Количество',
  Unit: 'Единица измерения',
  PurchasePrice: 'Цена закупки',
  Sum: 'Сумма',
  VatRate: 'Ставка НДС',
  VatAmount: 'Сумма НДС',
  Comment: 'Комментарий',
  Code: 'Код',
  PriceWithVat: 'Цена с НДС',
  Discount: 'Скидка',
  Country: 'Страна происхождения',
  CustomsDeclaration: 'Номер ГТД',
  ExpiryDate: 'Срок годности',
}

export const ROLE_OPTIONS: readonly { value: InvoiceColumnRole; label: string }[] = INVOICE_COLUMN_ROLES.map(
  (value) => ({ value, label: ROLE_LABELS[value] }),
)

/** Роли для профиля: «Не использовать» в профиле смысла не имеет (сервер отвергает). */
export const PROFILE_ROLE_OPTIONS = ROLE_OPTIONS.filter((option) => option.value !== 'None')

export const SEVERITY_LABELS: Readonly<Record<IssueSeverity, string>> = {
  Error: 'Ошибка',
  Warning: 'Предупреждение',
  Info: 'Сведение',
}

export const MATCHED_BY_LABELS: Readonly<Record<ProfileMatchedBy, string>> = {
  None: 'Профиль не подобран',
  Explicit: 'Профиль выбран вручную',
  Fingerprint: 'Профиль узнан по шапке таблицы',
  SupplierHint: 'Профиль подобран по поставщику',
  AutoDetect: 'Колонки распознаны автоматически',
}
